import {Serializer} from '~/app/core/common/serializers/serializer';
import {OrderingItemCategory} from '~/app/core/common/models/orderingItemCategory';
import {OrderItem} from '~/app/core/common/models/orderItem';

export class OrderItemSerializer implements Serializer {
    fromJson(json: any): OrderItem {
        const item = {} as OrderItem;
        item.itemNo = json.itemNo;
        item.activeFlagbool = json.activeFlag === 'H' ? false : true;
        item.activeFlag = json.activeFlag;
        item.buildToQty = json.buildToQty;
        item.bustype = json.bustype;
        item.categories = json.categories;
        item.critical = json.critical;
        item.maxQuantity = json.maxQuantity;
        item.minQuantity = json.minQuantity;
        item.daysSinceLast = json.daysSinceLast;
        item.unitOfMeasure = json.unitOfMeasure;
        item.showIndicator = json.showIndicator;
        item.categoryIndex = json.categoryIndex;
        item.custMax = json.custMax;
        item.description = json.description;
        item.openOrderQty = json.openOrderQty;
        item.sequence = json.sequence;
        item.qoh = json.qoh;
        item.qtyLastOrdered = json.qtyLastOrdered;
        item.restriction = json.restriction;
        item.perCost = json.perCost;
        item.quantity = json.quantity;
        item.price = json.price;
        item.qtySuggested = json.qtySuggested;
        item.itemCategories = [];

        if(json != null && json.categories != null) {
            const keys = Object.keys(json.categories);
            keys.forEach((key) => {
                const tempcat = new OrderingItemCategory();
                tempcat.categoryName = key;
                tempcat.sequence = +json.categories[key];
                item.itemCategories.push(tempcat);
            });
        }


        item.documentType = 'order_item';
        item.updated = false;
        return item;
    }

    toJson(resource: OrderItem) {
        return JSON.stringify(resource);
    }

}
